// src/components/contact/GoogleMap.jsx
import React from 'react';
import styles from './GoogleMap.module.css';

const GoogleMap = ({ city, region, country }) => {
  // const embedUrl = `https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d89261.69417434059!2d80.1086878!3d12.972102!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3a525e0863ffffff%3A0x6452588c80c79d48!2s2nd%20Floor%2C%20MSP%20Complex%2C%20opposite%20to%20Kumaran%20Cinemas%2C%20Vigneshwar%20Nagar%2C%20Balaji%20Nagar%2C%20Madipakkam%2C%20Chennai%2C%20Tamil%20Nadu%20600091!3m2!1d12.972114999999999!2d80.19108969999999!5e1!3m2!1sen!2sin!4v1756884256462!5m2!1sen!2sin`;
      const embedUrl = 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3887.9958001422538!2d80.1885148!3d12.9721202!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525e0863ffffff%3A0x6452588c80c79d48!2sBspark%20Software%20Technologies!5e0!3m2!1sen!2sin!4v1756884668894!5m2!1sen!2sin';


  return (
    <div className={styles.mapContainer}>
      <iframe
        title="Google Map"
        width="100%"
        height="500"
        frameBorder="0"
        style={{ border: 0 }}
        src={embedUrl}
        allowFullScreen=""
        aria-hidden="false"
        tabIndex="0"
      ></iframe>
    </div>
  );
};

export default GoogleMap;